import React from 'react';
import PropTypes from 'prop-types';
import LossToActionOverview from '../../LossToAction/LossToActionOverview';
const AllocationToDeliveryOverviewTable = ({
    data,
    columns,
    paginationData,
    sortingData,
    handlePageChange,
    isLoading = false
}) => {
    const scrollableColumnsArray = ['Order Loss Bucket','Order details','Customer Details','Freshness led loss validity','Order Loss Details','Allocation To Delivery Loss validity','Order validity details','PO Details','Reason of loss and loss bucket','Supply led loss validity'];
    return (
        <div style={{marginTop:"10px"}}>
        <LossToActionOverview
            data={data}
            columns={columns}
            paginationData={paginationData}
            sortingData={sortingData}
            handlePageChange={handlePageChange}
            isLoading={isLoading}
            scrollableColumnsArray={scrollableColumnsArray}
            totalColumnName="Format"
            fixedColumnName="Format"
            tableType="Allocation To Delivery Overview"
        />
        </div>
    );
};

export default AllocationToDeliveryOverviewTable;

AllocationToDeliveryOverviewTable.propTypes = {
    data: PropTypes.array,
    columns: PropTypes.array,
    paginationData: PropTypes.object,
    sortingData: PropTypes.object,
    handlePageChange: PropTypes.func,
    isLoading: PropTypes.bool,
};
